const store = {
    namespaced: true,
    state() {
        return {
            promotions: [],
            products: [],
            promoData: {}
        };
    },
    getters: {
        getPromotions(state) {
            return state.promotions;
        },
        getPromoData(state) {
            return state.promoData;
        },
        getProducts(state) {
            return state.products;
        }
    },
    mutations: {
        setProducts(state, products) {
            state.products = products;
        },
        addProducts(state, products) {
            state.products = state.products.concat(products);
        },
        setPromotions(state, promotions) {
            state.promotions = promotions;
        },
        SET_PROMO_DATA(state, promo) {
            state.promoData = promo;
        }
    },
    actions: {
        async fetchSpecialOffers({ commit }) {
            try {
                const promotions = await this.$axios.$get('general/promotions');

                commit('setPromotions', promotions);
            } catch (e) {
                console.error(e);
            }
        },
        async fetchPromoData({ commit }, id) {
            try {
                const promoData = await this.$axios.$get(`general/promotions/${id}`);

                commit('SET_PROMO_DATA', promoData);
            } catch (e) {
                console.error(e);
            }
        }
    }
};

export default store;
